window.buttonOrderFormatter = function(value, row) {
    let html = '';
    html += '<a class="button-order btn btn-success btn-sm" href="'+route('dashboard.cart.step_1', row.price_id)+'">';
    html += '<i class="fal fa-shopping-cart me-2"></i>';
    html += __('Bestellen');
    html += '</button>';
    return html;
};
